import { computed, openBlock, createElementBlock, normalizeClass, createElementVNode, toDisplayString, ref, watch, nextTick, createCommentVNode, Fragment, renderList, normalizeStyle, resolveComponent, createVNode, withCtx, renderSlot } from 'vue';
import { createComponent } from './utils/create-component';
import propTypes from './utils/prop-types';
import { CHANGE_EVENT, CANCEL_EVENT, CONFIRM_EVENT, INPUT_EVENT, HIDE_EVENT, MASK_CLICK_EVENT, SCROLL_STATE_CHANGED_EVENT } from './utils/constants';
import Popup from './popup';
import BScroll from '@better-scroll/core';
import Wheel from '@better-scroll/wheel';
import { isPromise } from './utils/validate';
import { noop } from './utils/function';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var props = {
  // 配置源数据
  data: propTypes.array().re(),
  // 自定义源数据的结构中的字段
  dataFieldNames: propTypes.object().def({
    text: 'text',
    disabled: 'disabled',
    value: 'value',
    children: 'children'
  }),
  // 列数
  cols: propTypes.number().re(),
  // 显隐配置
  modelValue: propTypes["boolean"]().def(true),
  // 默认选中值
  selectedValue: propTypes.array().def([]),
  // popup形式下显示的title
  title: propTypes.string().def(''),
  // popup形式下显示的取消文案
  cancelText: propTypes.string().def('取消'),
  // popup形式下显示的完成文案
  okText: propTypes.string().def('完成'),
  // 可支持配置的单个item normal selected 状态的行内样式
  itemStyles: propTypes.array().def([]),
  // 是否只读
  readonly: propTypes["boolean"]().def(false),
  // 是否为视图模式
  isView: propTypes["boolean"]().def(false),
  // 是否为级联模式
  isCascade: propTypes["boolean"]().def(false),
  // 是否支持mask关闭弹窗
  maskCloseable: propTypes["boolean"]().def(true),
  // 是否禁用外部滚动
  disableScroll: propTypes["boolean"]().def(true),
  // 是否需要底部安全区，只有popup形式支持
  needSafeArea: propTypes["boolean"]().def(true),
  // popup形式下取消前触发
  onBeforeCancel: propTypes["function"]().def(function () {
    return true;
  }),
  // popup形式下确认前触发
  onBeforeConfirm: propTypes["function"]().def(function () {
    return true;
  }),
  // 允许选项内容 HTML 渲染
  allowHtml: propTypes["boolean"]().def(false),
  // 是否开启即时联动效果
  isOpenInstantChange: propTypes["boolean"]().def(false)
};
var emits = [CHANGE_EVENT, CANCEL_EVENT, CONFIRM_EVENT, INPUT_EVENT, HIDE_EVENT, MASK_CLICK_EVENT];

var _createComponent$2 = createComponent('picker-title-bar'),
  create$2 = _createComponent$2.create,
  className$2 = _createComponent$2.className;
var script$2 = create$2({
  props: {
    // 中部title
    title: propTypes.string().def(''),
    // 左侧取消文案
    cancelText: propTypes.string().def('取消'),
    // 右侧完成文案
    okText: propTypes.string().def('完成'),
    // 右侧完成文案是否禁用
    okDisabled: propTypes["boolean"]().def(false)
  },
  // 取消、完成点击事件
  emits: [CANCEL_EVENT, CONFIRM_EVENT],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    function onCancelClick() {
      emit(CANCEL_EVENT);
    }
    function onConfirmClick() {
      emit(CONFIRM_EVENT);
    }
    var confirmTextClasses = computed(function () {
      var _ref2;
      return _ref2 = {}, _defineProperty(_ref2, "".concat(className$2, "__confirm_text"), true), _defineProperty(_ref2, "".concat(className$2, "__confirm_text_disabled"), props.okDisabled), _ref2;
    });
    return {
      className: className$2,
      onCancelClick: onCancelClick,
      onConfirmClick: onConfirmClick,
      confirmTextClasses: confirmTextClasses
    };
  }
});

function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    "class": normalizeClass(_ctx.className)
  }, [createElementVNode("div", {
    ref: "cancelText",
    "class": normalizeClass("".concat(_ctx.className, "__cancel_text")),
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.onCancelClick && _ctx.onCancelClick.apply(_ctx, arguments);
    })
  }, toDisplayString(_ctx.cancelText), 3 /* TEXT, CLASS */), createElementVNode("div", {
    "class": normalizeClass("".concat(_ctx.className, "__title"))
  }, toDisplayString(_ctx.title), 3 /* TEXT, CLASS */), createElementVNode("div", {
    ref: "confirmText",
    "class": normalizeClass(_ctx.confirmTextClasses),
    onClick: _cache[1] || (_cache[1] = function () {
      return _ctx.onConfirmClick && _ctx.onConfirmClick.apply(_ctx, arguments);
    })
  }, toDisplayString(_ctx.okText), 3 /* TEXT, CLASS */)], 2 /* CLASS */);
}

script$2.render = render$2;
script$2.__file = "components/src/component/picker/picker-title-bar.vue";

var _createComponent$1 = createComponent('picker-view'),
  create$1 = _createComponent$1.create,
  className$1 = _createComponent$1.className;
// 滚动事件
var WHEEL_INDEX_CHANGED = 'wheelIndexChanged';
BScroll.use(Wheel);
var script$1 = create$1({
  props: {
    // 配置数据源
    data: propTypes.array().def([]),
    // 自定义源数据的结构中的字段
    dataFieldNames: propTypes.object().def({
      text: 'text',
      disabled: 'disabled',
      value: 'value',
      children: 'children'
    }),
    // 列数
    cols: propTypes.number().re(),
    // 默认被选中的值数组
    selectedValue: propTypes.array().def([]),
    // 是否只读
    readonly: propTypes["boolean"]().def(false),
    // 是否为级联类型
    isCascade: propTypes["boolean"]().def(false),
    // 是否可见
    isVisible: propTypes["boolean"]().def(false),
    // 单列每个条目可配置的行内样式
    itemStyles: propTypes.array().def([]),
    allowHtml: propTypes["boolean"]().def(false),
    // 是否开启即时联动效果
    isOpenInstantChange: propTypes["boolean"]().def(false)
  },
  // 数据变更事件
  emits: [CHANGE_EVENT, SCROLL_STATE_CHANGED_EVENT],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    // 初始化滚轮的容器
    var wheelWrapper = ref(null);
    // 滚动列表
    var wheelListWrapper = ref(null);
    // 选中列下标组
    var selectedIndexPair = ref([]);
    // BS实例组
    var wheels = ref([]);
    // picker处理后要渲染的数据
    var computedPickerData = computed(function () {
      // 级联与非级联类型区分处理数据，先分类型初步重组数据，再统一处理
      return formatPickerData(props.isCascade ? formatCascadeData() : formatNotCascadeData());
    });
    // 是否在级联状态下关闭即时联动效果
    var isCloseInstantChange = computed(function () {
      return props.isCascade && !props.isOpenInstantChange;
    });
    /**
     * @description: 初始化，区分级联与非级联
     */
    function init() {
      // 级联与非级联类型区分处理初始化选中index
      props.isCascade ? initCascadeSelectedIndex() : initNotCascadeSelectedIndex();
      // 如果可视，则进行滚轮初始化及复位
      if (props.isVisible) {
        initWheel();
        initPosition();
      }
    }
    /**
     * @description: 初始化级联类型选中index
     */
    function initCascadeSelectedIndex() {
      // 从配置项中取出对应关系
      var dataFieldNames = props.dataFieldNames;
      var _dataFieldNames$value = dataFieldNames.value,
        value = _dataFieldNames$value === void 0 ? 'value' : _dataFieldNames$value,
        _dataFieldNames$child = dataFieldNames.children,
        children = _dataFieldNames$child === void 0 ? 'children' : _dataFieldNames$child;
      // 如果没有默认选中值，则都填充为第0个选中
      if (props.selectedValue.length === 0) {
        selectedIndexPair.value = Array(props.cols).fill(0);
      } else {
        var lastParent;
        var lastSelectIndex = 0;
        var middleSelectedIndexArr = [];
        props.selectedValue.map(function (targetValue, ind) {
          // 首个直接赋值传入配置项
          if (ind === 0) {
            lastParent = _toConsumableArray(props.data[0]);
          } else {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            // 由于外部用户传入结构支持配置，因此不再做结构校验
            lastParent = lastParent && lastParent[lastSelectIndex] && lastParent[lastSelectIndex][children];
          }
          if (lastParent) {
            var searchIndex = lastParent.findIndex(
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            // 由于外部用户传入结构支持配置，因此不再做结构校验
            function (item) {
              return item[value] === targetValue;
            });
            var targetIndex = lastSelectIndex = searchIndex !== -1 ? searchIndex : 0;
            middleSelectedIndexArr.push(targetIndex);
          } else {
            middleSelectedIndexArr.push(0);
          }
        });
        selectedIndexPair.value = middleSelectedIndexArr;
      }
    }
    /**
     * @description: 初始化非级联类型选中index
     */
    function initNotCascadeSelectedIndex() {
      // 从配置项中取出对应关系
      var dataFieldNames = props.dataFieldNames;
      var _dataFieldNames$value2 = dataFieldNames.value,
        value = _dataFieldNames$value2 === void 0 ? 'value' : _dataFieldNames$value2;
      var middleSelectedIndexArr = [];
      // 遍历数据，找到value对应的index
      computedPickerData.value.forEach(function (colData, colIndex) {
        var targetIndex = colData.findIndex(
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // 由于外部用户传入结构支持配置，因此不再做结构校验
        function (item) {
          return item[value] === props.selectedValue[colIndex];
        });
        middleSelectedIndexArr[colIndex] = targetIndex !== -1 ? targetIndex : 0;
      });
      selectedIndexPair.value = middleSelectedIndexArr;
    }
    /**
     * @description: 初始化滚轮
     */
    function initWheel() {
      nextTick(function () {
        for (var i = 0; i < computedPickerData.value.length; i++) {
          createWheel(wheelWrapper.value, i);
        }
      });
    }
    /**
     * @description: 初始化滚动至选中位置
     */
    function initPosition() {
      wheels.value.forEach(function (_, i) {
        wheelTo(i, selectedIndexPair.value[i], false);
      });
    }
    /**
     * @description: 创建滚轮
     * @param {*} wheelWrapper 滚轮父容器
     * @param {*} i 创建的个数
     * @return {*} BS实例
     */
    function createWheel(wheelWrapper, i) {
      // 是否在滚动中标识位
      var isScroll = false;
      // 上次滚动选中的结果值
      var lastTarget = null;
      // 如果已经实例化，则不重复创建，只更新滚动区域
      if (!wheels.value[i]) {
        // 实例化
        // 当点击某一项的时候，滚动过去的动画时长(当级联状态下，未开启即时联动效果时需要指定200ms动画时长，否则滑动过程中用户拖动时无法选中)
        var adjustTime = isCloseInstantChange.value ? 200 : 0;
        wheels.value[i] = new BScroll(wheelWrapper.children[i], {
          wheel: {
            rotate: 0,
            adjustTime: adjustTime,
            selectedIndex: selectedIndexPair.value[i],
            wheelWrapperClass: "".concat(className$1, "__wheel_scroll"),
            wheelItemClass: "".concat(className$1, "__wheel_item"),
            wheelDisabledItemClass: "".concat(className$1, "__wheel_item-disabled")
          },
          probeType: 3,
          bounceTime: 600
        });
        // 绑定滚动选中事件，由于在vue-test-utils中无法触发BS事件，因此排除不做测试覆盖度验证
        /* istanbul ignore next */
        wheels.value[i].on(WHEEL_INDEX_CHANGED, function (selectedIndex) {
          nextTick(function () {
            // 区分级联与非级联进行响应
            props.isCascade ? handleCascadeSelectedChange(i, selectedIndex) : handleNotCascadeSelectedChange(i, selectedIndex);
          });
        });
        // 实现跟手效果
        // 绑定滚动开始事件，由于在vue-test-utils中无法触发BS事件，因此排除不做测试覆盖度验证
        /* istanbul ignore next */
        wheels.value[i].on('scrollStart', function () {
          // 滚动开始时启动滚动跟手
          isScroll = true;
          handleScrollStateChange(isScroll);
        });
        // 绑定滚动结束事件，由于在vue-test-utils中无法触发BS事件，因此排除不做测试覆盖度验证
        /* istanbul ignore next */
        wheels.value[i].on('scrollEnd', function () {
          // 滚动结束时关闭滚动跟手
          isScroll = false;
          handleScrollStateChange(isScroll);
        });
        // 绑定滚动事件，由于在vue-test-utils中无法触发BS事件，因此排除不做测试覆盖度验证
        /* istanbul ignore next */
        wheels.value[i].on('scroll', function (position) {
          // 未开启时不做处理 || 级联状态下关闭即时联动效果时不做处理
          if (!isScroll || isCloseInstantChange.value) return;
          // 兼容picker列表无法通过ref获取到的场景
          var targetScrollWrapper = wheelWrapper.children[i].querySelector('.spu-picker-view__wheel_scroll');
          var targetWheel = wheelListWrapper.value[i] || targetScrollWrapper || {};
          // 获取子元素个数，处理边界条件
          var listLen = targetWheel.children.length;
          if (listLen) {
            // 获取单个元素实际高度用于计算
            var height = targetWheel.children[0].offsetHeight;
            // 获取当前滚动位置合适的目标
            var target = Number((Math.abs(position.y) / height).toFixed(0));
            var targetTemp = target;
            // 当滚动位置>0时，说明已经超出第一个位置
            if (position.y > 0) {
              target = 0;
              // 当滚动位置大于最后一个时，说明已经超出最后一个
            } else if (target >= listLen - 1) {
              target = listLen - 1;
            }
            // 首次滚动时需要记录上一次的最终滚动结果
            if (lastTarget === null) lastTarget = target;
            // 如果小距离重复拖动，就直接返回，避免重复操作
            if (lastTarget === target) {
              // 停止滚动操作，否则在边界条件下 better-scroll 会继续执行滚动操作，导致报错及体验问题；
              // stopWheels()方法会导致惯性效果消失！！！
              props.isCascade && stopWheels();
              return;
            } else {
              // 如果两者值不同，则进行切换操作
              lastTarget = target;
              selectedIndexPair.value.splice(i, 1, target);
              // 切换后停止滚动操作，否则在边界条件下（超出第一个/大于最后一个） better-scroll 会继续执行滚动操作，导致报错及体验问题；
              if (position.y > 0 || targetTemp >= listLen - 1) {
                stopWheels();
                return;
              }
            }
          }
        });
      } else {
        // 已实例化过的只重新计算滚动区域
        wheels.value[i].refresh();
      }
      // 增加只读显示能力
      props.readonly ? wheels.value[i].disable() : wheels.value[i].enable();
      return wheels.value[i];
    }
    /**
     * @description: 非级联类型选中切换
     */
    function handleNotCascadeSelectedChange(colIndex, selectedIndex) {
      // 切换选中序号
      setSelectedIndexPair(colIndex, 1, selectedIndex);
      emitChange(colIndex);
    }
    /**
     * @description: 级联类型选中切换
     */
    function handleCascadeSelectedChange(colIndex, selectedIndex) {
      // 判断需要补全的位数，如果是最深层级无需补全
      var coverageLen = props.cols - (colIndex + 1);
      // 补位数字
      var coverage = Array(coverageLen).fill(0);
      // 调整选中内容
      setSelectedIndexPair.apply(void 0, [colIndex, 1 + coverageLen, selectedIndex].concat(_toConsumableArray(coverage)));
      emitChange(colIndex);
    }
    function handleScrollStateChange(isScroll) {
      emit(SCROLL_STATE_CHANGED_EVENT, isScroll);
    }
    /**
     * @description: 抽取触发change事件的通用逻辑
     * @param {*} colIndex 本次修改的列索引
     * @return {*}
     */
    function emitChange(colIndex) {
      var _getSelectedInfo = getSelectedInfo(),
        values = _getSelectedInfo.values,
        items = _getSelectedInfo.items;
      emit(CHANGE_EVENT, values, items, colIndex);
      // 切换完成后重新计算可滚动区域高度
      nextTick(function () {
        refreshWheels();
        initPosition();
      });
    }
    /**
     * @description: 组织非级联类型数据
     */
    function formatNotCascadeData() {
      // 从配置项中取出对应关系
      var dataFieldNames = props.dataFieldNames;
      // 增加extend字段，当配置时会从传入数据中获取并在选中时对外抛出
      var _dataFieldNames$text = dataFieldNames.text,
        text = _dataFieldNames$text === void 0 ? 'text' : _dataFieldNames$text,
        _dataFieldNames$value3 = dataFieldNames.value,
        value = _dataFieldNames$value3 === void 0 ? 'value' : _dataFieldNames$value3,
        _dataFieldNames$disab = dataFieldNames.disabled,
        disabled = _dataFieldNames$disab === void 0 ? 'disabled' : _dataFieldNames$disab,
        _dataFieldNames$exten = dataFieldNames.extend,
        extend = _dataFieldNames$exten === void 0 ? '' : _dataFieldNames$exten;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // 由于外部用户传入结构支持配置，因此不再做结构校验
      return props.data.map(function (colList) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // 由于外部用户传入结构支持配置，因此不再做结构校验
        return colList.map(function (item) {
          return {
            text: item[text],
            value: item[value],
            disabled: item[disabled] || false,
            extend: extend ? item[extend] : ''
          };
        });
      });
    }
    /**
     * @description: 组织级联类型数据，逐层寻找对应数据
     */
    function formatCascadeData() {
      // 从配置项中取出对应关系
      var dataFieldNames = props.dataFieldNames;
      // 增加extend字段，当配置时会从传入数据中获取并在选中时对外抛出
      var _dataFieldNames$text2 = dataFieldNames.text,
        text = _dataFieldNames$text2 === void 0 ? 'text' : _dataFieldNames$text2,
        _dataFieldNames$value4 = dataFieldNames.value,
        value = _dataFieldNames$value4 === void 0 ? 'value' : _dataFieldNames$value4,
        _dataFieldNames$disab2 = dataFieldNames.disabled,
        disabled = _dataFieldNames$disab2 === void 0 ? 'disabled' : _dataFieldNames$disab2,
        _dataFieldNames$child2 = dataFieldNames.children,
        children = _dataFieldNames$child2 === void 0 ? 'children' : _dataFieldNames$child2,
        _dataFieldNames$exten2 = dataFieldNames.extend,
        extend = _dataFieldNames$exten2 === void 0 ? '' : _dataFieldNames$exten2;
      var middleData = [];
      var lastParent = [];
      var lastSelectIndex = 0;
      selectedIndexPair.value.map(function (colSelectedIndex, ind) {
        if (ind === 0) {
          lastParent = props.data.slice(0, 1)[0];
        } else {
          lastParent = lastParent && lastParent[lastSelectIndex] && lastParent[lastSelectIndex][children];
        }
        lastSelectIndex = colSelectedIndex;
        if (lastParent) {
          middleData.push(
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          // 由于外部用户传入结构支持配置，因此不再做结构校验
          lastParent.map(function (item) {
            return {
              text: item[text],
              value: item[value],
              disabled: item[disabled] || false,
              extend: extend ? item[extend] : ''
            };
          }));
        } else {
          middleData.push([]);
        }
      });
      return middleData;
    }
    function formatPickerData(data) {
      return data.map(function (col, colIndex) {
        return col.map(function (item, itemIndex) {
          var _class;
          var text = item.text,
            value = item.value,
            _item$disabled = item.disabled,
            disabled = _item$disabled === void 0 ? false : _item$disabled,
            _item$extend = item.extend,
            extend = _item$extend === void 0 ? '' : _item$extend;
          var _ref2 = props.itemStyles[colIndex] || {},
            _ref2$normal = _ref2.normal,
            normal = _ref2$normal === void 0 ? {} : _ref2$normal,
            _ref2$selected = _ref2.selected,
            selected = _ref2$selected === void 0 ? {} : _ref2$selected;
          var isTarget = itemIndex === selectedIndexPair.value[colIndex];
          return {
            text: text,
            value: value,
            disabled: disabled,
            extend: extend,
            style: isTarget ? selected : normal,
            "class": (_class = {}, _defineProperty(_class, "".concat(className$1, "__wheel_item"), true), _defineProperty(_class, "".concat(className$1, "__wheel_item-disabled"), disabled), _class)
          };
        });
      });
    }
    /**
     * @description: 逐级遍历获取选中信息
     * @return {*} {values, items} values:选中的值数组 items:选中的值及其配置信息 options
     */
    function getSelectedInfo() {
      var values = [];
      var items = [];
      selectedIndexPair.value.forEach(function (selectedIndex, colIndex) {
        if (computedPickerData.value[colIndex] && computedPickerData.value[colIndex][selectedIndex]) {
          var _computedPickerData$v = computedPickerData.value[colIndex][selectedIndex],
            value = _computedPickerData$v.value,
            text = _computedPickerData$v.text,
            disabled = _computedPickerData$v.disabled,
            extend = _computedPickerData$v.extend;
          values.push(value);
          items.push({
            value: value,
            text: text,
            disabled: disabled,
            extend: extend
          });
        }
      });
      return {
        values: values,
        items: items
      };
    }
    /**
     * @description: 重新计算可滚动高度
     */
    function refreshWheels() {
      wheels.value.forEach(function (wheel) {
        wheel.refresh();
      });
    }
    /**
     * @description: 立即停止当前运行的滚动动画
     */
    function stopWheels() {
      wheels.value.forEach(function (wheel) {
        wheel.stop();
      });
    }
    /**
     * @description: 滚轮滚动到某一位置
     * @param {*} wheelIndex 要操作的滚轮的index
     * @param {*} selectedIndex 滚轮要被选中的项的index
     */
    function wheelTo(wheelIndex, selectedIndex) {
      var isForce = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var targetIndex = selectedIndex || 0;
      var targetWheel = wheels.value[wheelIndex];
      // 这个场景只有在渲染时才会触发，jest时不会触发
      /* istanbul ignore next */
      if (targetWheel.plugins.wheel.items.length < targetIndex) {
        // 这个场景只有在渲染时才会触发，jest时不会触发
        /* istanbul ignore next */
        setTimeout(function () {
          wheels.value[wheelIndex] && wheels.value[wheelIndex].wheelTo(targetIndex);
        }, 0);
      } else {
        if (wheels.value[wheelIndex] && computedPickerData.value[wheelIndex]) {
          wheels.value[wheelIndex].wheelTo(targetIndex);
        }
      }
      if (isForce) {
        props.isCascade ? handleCascadeSelectedChange(wheelIndex, targetIndex) : handleNotCascadeSelectedChange(wheelIndex, targetIndex);
      }
    }
    /**
     * @description: 设置选中的顺序
     * @param {*} startIndex 起始序号
     * @param {*} len 修改的个数
     * @param {array} rest 修改的内容参数
     */
    function setSelectedIndexPair(startIndex, len) {
      var _selectedIndexPair$va;
      for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        rest[_key - 2] = arguments[_key];
      }
      (_selectedIndexPair$va = selectedIndexPair.value).splice.apply(_selectedIndexPair$va, [startIndex, len].concat(rest));
    }
    watch(function () {
      return props.data;
    }, function () {
      // 数据发生变化时，进行初始化
      init();
      nextTick(function () {
        initPosition();
      });
    }, {
      immediate: true,
      deep: true
    });
    watch(function () {
      return props.selectedValue;
    }, function () {
      init();
      // 选中值发生变化时，只重置选中位置
      nextTick(function () {
        initPosition();
      });
    }, {
      immediate: true,
      deep: true
    });
    watch(function () {
      return props.isVisible;
    }, function (newVal) {
      if (newVal) {
        // 显隐发生变化时，进行初始化
        init();
        nextTick(function () {
          initPosition();
        });
      }
    }, {
      immediate: true
    });
    return {
      computedPickerData: computedPickerData,
      wheelWrapper: wheelWrapper,
      wheelListWrapper: wheelListWrapper,
      className: className$1,
      initPosition: initPosition,
      refreshWheels: refreshWheels,
      getSelectedInfo: getSelectedInfo,
      wheelTo: wheelTo,
      setSelectedIndexPair: setSelectedIndexPair,
      selectedIndexPair: selectedIndexPair
    };
  }
});

var _hoisted_1 = ["innerHTML"];
var _hoisted_2 = {
  key: 1
};
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    "class": normalizeClass(_ctx.className)
  }, [createElementVNode("div", {
    "class": normalizeClass("".concat(_ctx.className, "__content"))
  }, [createCommentVNode(" picker顶部线 "), createElementVNode("div", {
    "class": normalizeClass("".concat(_ctx.className, "__mask_top"))
  }, null, 2 /* CLASS */), createCommentVNode(" picker底部线 "), createElementVNode("div", {
    "class": normalizeClass("".concat(_ctx.className, "__mask_bottom"))
  }, null, 2 /* CLASS */), createCommentVNode(" picker滚轮容器 "), createElementVNode("div", {
    "class": normalizeClass("".concat(_ctx.className, "__wheel_wrapper")),
    ref: "wheelWrapper"
  }, [createCommentVNode(" picker列实例 "), (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.computedPickerData, function (data, pickerIndex) {
    return openBlock(), createElementBlock("div", {
      "class": normalizeClass("".concat(_ctx.className, "__wheel")),
      key: pickerIndex
    }, [createElementVNode("ul", {
      "class": normalizeClass("".concat(_ctx.className, "__wheel_scroll")),
      ref_for: true,
      ref: "wheelListWrapper"
    }, [(openBlock(true), createElementBlock(Fragment, null, renderList(data, function (item, ind) {
      return openBlock(), createElementBlock("li", {
        key: item.value,
        "class": normalizeClass(_objectSpread2(_defineProperty({}, "".concat(_ctx.className, "__wheel_item-selected"), ind === _ctx.selectedIndexPair[pickerIndex]), item["class"])),
        style: normalizeStyle(item.style)
      }, [_ctx.allowHtml ? (openBlock(), createElementBlock("span", {
        key: 0,
        innerHTML: item.text
      }, null, 8 /* PROPS */, _hoisted_1)) : (openBlock(), createElementBlock("span", _hoisted_2, toDisplayString(item.text), 1 /* TEXT */))], 6 /* CLASS, STYLE */);
    }), 128 /* KEYED_FRAGMENT */))], 2 /* CLASS */)], 2 /* CLASS */);
  }), 128 /* KEYED_FRAGMENT */))], 2 /* CLASS */)], 2 /* CLASS */)], 2 /* CLASS */);
}

script$1.render = render$1;
script$1.__file = "components/src/component/picker/picker-view.vue";

var _components;
var _createComponent = createComponent('picker'),
  create = _createComponent.create,
  className = _createComponent.className;
var script = create({
  props: props,
  components: (_components = {}, _defineProperty(_components, Popup.name, Popup), _defineProperty(_components, script$2.name, script$2), _defineProperty(_components, script$1.name, script$1), _components),
  emits: emits,
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    // 单独使用的picker实例
    var singlePicker = ref(null);
    // popup形式下的picker实例
    var popupPicker = ref(null);
    // 内部选中信息
    var innerSelectedValue = ref([]);
    // picker的【完成】键是否禁用
    var okDisabled = ref(false);
    // 是否展示picker
    var isShowPicker = computed({
      get: function get() {
        return props.modelValue;
      },
      set: function set(isShow) {
        emit(INPUT_EVENT, isShow);
      }
    });
    // 根据isView判断目标picker
    var targetPicker = computed(function () {
      return props.isView ? singlePicker.value : popupPicker.value;
    });
    // 根据needSafeArea 判断class
    var pickerContainerClass = computed(function () {
      var _ref2;
      return _ref2 = {}, _defineProperty(_ref2, "".concat(className, "__container"), true), _defineProperty(_ref2, "".concat(className, "__container-safe"), props.needSafeArea), _ref2;
    });
    /**
     * @description: 取消逻辑
     */
    function onCancel() {
      isShowPicker.value = false;
      targetPicker.value.initPosition();
      emit(CANCEL_EVENT);
    }
    /**
     * @description: 取消响应事件
     */
    function onCancelClick() {
      var response = props.onBeforeCancel();
      if (response !== false) {
        onCancel();
        return;
      }
      if (isPromise(response)) {
        response.then(function (result) {
          if (result !== false) {
            onCancel();
          }
        })["catch"](noop);
      }
    }
    /**
     * @description: 确认逻辑
     * @return {*}
     */
    function onConfirm() {
      var _targetPicker$value$g = targetPicker.value.getSelectedInfo(),
        values = _targetPicker$value$g.values,
        items = _targetPicker$value$g.items;
      isShowPicker.value = false;
      emit(CONFIRM_EVENT, values, items);
    }
    /**
     * @description: 完成响应事件
     */
    function onConfirmClick() {
      var response = props.onBeforeConfirm();
      if (response !== false) {
        onConfirm();
        return;
      }
      if (isPromise(response)) {
        response.then(function (result) {
          if (result !== false) {
            onConfirm();
          }
        })["catch"](noop);
      }
    }
    /**
     * @description: 滚轮change事件回调
     * @param {*} values
     * @param {*} items
     * @return {*}
     */
    function onPickerChange(values, items, colIndex) {
      emit(CHANGE_EVENT, values, items, colIndex);
    }
    /**
     * @description: 滑动状态改变
     * @param {*} isScroll 滑动的状态（滑动中；非滑动中）
     * @return {*}
     */
    function onScrollStateChange(isScroll) {
      okDisabled.value = isScroll;
    }
    /**
     * @description: 滚轮滚动到某一位置
     * @param {*} wheelIndex 要操作的滚轮的index
     * @param {*} selectedIndex 滚轮要被选中的项的index
     */
    function wheelTo(wheelIndex, selectedIndex) {
      targetPicker.value.wheelTo(wheelIndex, selectedIndex);
    }
    /**
     * @description: 逐级遍历获取选中信息
     * @return {*} {values, items} values:选中的值数组 items:选中的值及其配置信息 options
     */
    function getSelectedInfo() {
      return targetPicker.value.getSelectedInfo();
    }
    /**
     * @description: 当popup隐藏时触发
     */
    function onPopupHide() {
      emit(HIDE_EVENT);
    }
    /**
     * @description: 当popup mask被点击时触发
     */
    function onPopupMaskClick() {
      emit(MASK_CLICK_EVENT);
    }
    watch(function () {
      return props.selectedValue;
    }, function (newVal) {
      // 兼容null与undefined类型
      if (newVal !== null && newVal !== undefined) {
        innerSelectedValue.value = newVal;
      } else {
        innerSelectedValue.value = [];
      }
    }, {
      immediate: true
    });
    return {
      className: className,
      singlePicker: singlePicker,
      popupPicker: popupPicker,
      isShowPicker: isShowPicker,
      pickerContainerClass: pickerContainerClass,
      innerSelectedValue: innerSelectedValue,
      onCancelClick: onCancelClick,
      onConfirmClick: onConfirmClick,
      onPickerChange: onPickerChange,
      onPopupHide: onPopupHide,
      onPopupMaskClick: onPopupMaskClick,
      wheelTo: wheelTo,
      getSelectedInfo: getSelectedInfo,
      okDisabled: okDisabled,
      onScrollStateChange: onScrollStateChange
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_sp_picker_view = resolveComponent("sp-picker-view");
  var _component_sp_picker_title_bar = resolveComponent("sp-picker-title-bar");
  var _component_sp_popup = resolveComponent("sp-popup");
  return openBlock(), createElementBlock("div", {
    "class": normalizeClass(_ctx.className)
  }, [createCommentVNode(" 如果是view类型，就不依赖popup "), _ctx.isView ? (openBlock(), createElementBlock(Fragment, {
    key: 0
  }, [createCommentVNode(" picker容器 "), createVNode(_component_sp_picker_view, {
    ref: "singlePicker",
    data: _ctx.data,
    dataFieldNames: _ctx.dataFieldNames,
    readonly: _ctx.readonly,
    "is-visible": _ctx.modelValue,
    "is-cascade": _ctx.isCascade,
    allowHtml: _ctx.allowHtml,
    "selected-value": _ctx.innerSelectedValue,
    "item-styles": _ctx.itemStyles,
    cols: _ctx.cols,
    isOpenInstantChange: _ctx.isOpenInstantChange,
    onChange: _ctx.onPickerChange
  }, null, 8 /* PROPS */, ["data", "dataFieldNames", "readonly", "is-visible", "is-cascade", "allowHtml", "selected-value", "item-styles", "cols", "isOpenInstantChange", "onChange"])], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)) : (openBlock(), createElementBlock(Fragment, {
    key: 1
  }, [createCommentVNode(" 否则就是popup类型展示 "), createVNode(_component_sp_popup, {
    modelValue: _ctx.isShowPicker,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.isShowPicker = $event;
    }),
    "show-mask": true,
    "mask-closeable": _ctx.maskCloseable,
    "disable-scroll": _ctx.disableScroll,
    onHide: _ctx.onPopupHide,
    onMaskClick: _ctx.onPopupMaskClick,
    position: "bottom"
  }, {
    "default": withCtx(function () {
      return [createCommentVNode(" 顶部title bar "), createVNode(_component_sp_picker_title_bar, {
        title: _ctx.title,
        "cancel-text": _ctx.cancelText,
        "ok-text": _ctx.okText,
        "ok-disabled": _ctx.okDisabled,
        onCancel: _ctx.onCancelClick,
        onConfirm: _ctx.onConfirmClick
      }, null, 8 /* PROPS */, ["title", "cancel-text", "ok-text", "ok-disabled", "onCancel", "onConfirm"]), createElementVNode("div", {
        "class": normalizeClass(_ctx.pickerContainerClass)
      }, [renderSlot(_ctx.$slots, "customized-middle-part"), createCommentVNode(" 下方picker容器，安全区在这处理 "), createVNode(_component_sp_picker_view, {
        ref: "popupPicker",
        data: _ctx.data,
        dataFieldNames: _ctx.dataFieldNames,
        readonly: _ctx.readonly,
        "is-visible": _ctx.modelValue,
        "is-cascade": _ctx.isCascade,
        allowHtml: _ctx.allowHtml,
        "selected-value": _ctx.innerSelectedValue,
        "item-styles": _ctx.itemStyles,
        cols: _ctx.cols,
        isOpenInstantChange: _ctx.isOpenInstantChange,
        onChange: _ctx.onPickerChange,
        onScrollStateChange: _ctx.onScrollStateChange
      }, null, 8 /* PROPS */, ["data", "dataFieldNames", "readonly", "is-visible", "is-cascade", "allowHtml", "selected-value", "item-styles", "cols", "isOpenInstantChange", "onChange", "onScrollStateChange"]), renderSlot(_ctx.$slots, "customized-bottom-part")], 2 /* CLASS */)];
    }),

    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["modelValue", "mask-closeable", "disable-scroll", "onHide", "onMaskClick"])], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))], 2 /* CLASS */);
}

script.render = render;
script.__file = "components/src/component/picker/picker.vue";

var _Picker = script;

export { _Picker as default };
